import React, { CSSProperties, useState } from 'react';
import { RENAISSANCE_COLORS } from '../utils';
import { Link } from 'react-router-dom';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

import "./Header.css";

const BASE_URL = process.env.REACT_APP_BASE_URL ?? 'http://localhost:5000';

const Header: React.FC = () => {
    const [adminAnchorEl, setAdminAnchorEl] = useState<null | HTMLElement>(null);
    const adminMenuOpen = Boolean(adminAnchorEl);
    const { instance } = useMsal();

    // /docs is opened as a plain browser navigation (window.open can't set
    // custom headers), so - same as the old FRONTEND_PASSWORD-era mechanism -
    // the ID token is passed as a one-time ?token= query param; main.py
    // swaps it for a short-lived cookie on first load (SCINFRA-686).
    const handleApiDocs = async () => {
        const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
        if (!account) {
            return;
        }
        const result = await instance.acquireTokenSilent({ ...loginRequest, account });
        const url = `${BASE_URL}/docs?token=${encodeURIComponent(result.idToken)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleSignOut = () => {
        instance.logoutRedirect();
    };

    const handleAdminMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAdminAnchorEl(event.currentTarget);
    };

    const handleAdminMenuClose = () => {
        setAdminAnchorEl(null);
    };

    return (
        <header style={styles.header}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <Link style={{ textDecoration: "none" }} to="/">
                    <h1 onClick={() => window.location.href = '/'} style={styles.rock}>AI Scoring Evaluation Service</h1>
                </Link>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        component={Link}
                        to="/evaluation"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Evaluation
                    </Button>
                    <Button
                        component={Link}
                        to="/datasets"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Datasets
                    </Button>
                    <Button
                        component={Link}
                        to="/wpevalrun"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        WP Evaluation
                    </Button>
                    <Button
                        component={Link}
                        to="/crevalrun"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        CR Evaluation
                    </Button>
                    <Button
                        component={Link}
                        to="/evaluations"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Evaluations
                    </Button>
                    <Button
                        component={Link}
                        to="/results"
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Results
                    </Button>
                    <Button
                        onClick={handleApiDocs}
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        API Docs
                    </Button>
                    <Button
                        onClick={handleAdminMenuClick}
                        color="inherit"
                        endIcon={<ArrowDropDown />}
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Admin
                    </Button>
                    <Menu
                        anchorEl={adminAnchorEl}
                        open={adminMenuOpen}
                        onClose={handleAdminMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            component={Link}
                            to="/admin/prompts"
                            onClick={handleAdminMenuClose}
                        >
                            Prompt Templates
                        </MenuItem>
                        <MenuItem
                            component={Link}
                            to="/admin/mappings"
                            onClick={handleAdminMenuClose}
                        >
                            Attribute Mappings
                        </MenuItem>
                        <MenuItem
                            component={Link}
                            to="/admin/variables"
                            onClick={handleAdminMenuClose}
                        >
                            Variable Registry
                        </MenuItem>
                        <MenuItem
                            component={Link}
                            to="/admin/products"
                            onClick={handleAdminMenuClose}
                        >
                            Products
                        </MenuItem>
                    </Menu>
                    <Button
                        onClick={handleSignOut}
                        color="inherit"
                        sx={{ color: RENAISSANCE_COLORS.black }}
                    >
                        Sign Out
                    </Button>
                </Box>
            </Box>
        </header>
    );
};

const styles: { [key: string]: CSSProperties } = {
    header: {
        backgroundColor: RENAISSANCE_COLORS.white,
        padding: '12px 24px',
        borderBottom: `1px solid ${RENAISSANCE_COLORS.lightgrey}`,
        boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
    },
    rock: {
        color: RENAISSANCE_COLORS.black,
        margin: 0,
        fontSize: '1.5rem',
        fontWeight: 'bold'
    }
};

export default Header;